<template>
    <div class="container">
        <div class="row justify-content-center">
            <transition name="fade" mode="out-in">
                <!-- Se a mensagem não foi clicada, mostrar o coração com o texto "Clique aqui" -->
                <div @click="mostrarMensagem()" v-if="!mostrar_mensagem" class="col-12 col-md-6">
                    <img class="img-fluid heart" src="../assets/coracao.webp">
                    <div class="heart-text">Clique aqui</div>
                </div>

                <!-- Quando o coração é clicado, mostrar a mensagem com animação -->
                <div v-else class="col text-center">
                    <transition name="bounce" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                        <p class="mensagem animate__animated animate__bounceIn">{{ mensagem }}</p>
                    </transition>
                    <!-- Corações flutuantes -->
                    <transition-group name="float-hearts" tag="div" @before-enter="beforeEnterHeart" @enter="enterHeart"
                        @leave="leaveHeart">
                        <div v-for="(heart, index) in floatingHearts" :key="index" class="floating-heart"
                            :style="getHeartStyle(heart)"></div>
                    </transition-group>
                </div>
            </transition>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
    components: {}
})
export default class iLoveYou extends Vue {
    mostrar_mensagem = false
    mensagem = 'I Love You, Yali <3'

    floatingHearts = Array.from({ length: 10 }, () => ({
        size: Math.random() * 90 + 70,
        side: Math.random() < 0.5 ? 'left' : 'right',
        position: Math.random() * 100,
        delay: Math.random() * 2
    }));

    public mostrarMensagem() {
        this.mostrar_mensagem = true;
    }

    getHeartStyle(heart: { size: number, side: string, position: number, delay: number }) {
        return {
            width: `${heart.size}px`,
            height: `${heart.size}px`,
            [heart.side]: `${heart.position}%`,
            animationDelay: `${heart.delay}s`
        };
    }

    public beforeEnterHeart(el: HTMLElement) {
        el.style.opacity = '0';
        el.style.transition = 'opacity 1s ease';
    }

    public enterHeart(el: HTMLElement, done: () => void) {
        el.offsetHeight;
        el.style.opacity = '1';
        done();
    }

    public leaveHeart(el: HTMLElement, done: () => void) {
        el.style.opacity = '0';
        setTimeout(done, 1000);
    }
}
</script>

<style lang="scss">
@import '../scss/styles.scss';

html,
body {
    overflow-x: hidden;
    /* Esconde o scroll horizontal */
    margin: 0;
    padding: 0;
}
</style>